import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignal1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 36,
	viewBox: "0 0 44 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 27,
			width: 6,
			height: 6,
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 13,
			width: 10,
			height: 22,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33,
			y: 1,
			width: 10,
			height: 34,
			strokeWidth: 2
		})
	]
});
export default SvgSignal1;
